<app-layout>
  <app-urun-grup-sec-modal [source]="urunGruplar" [show]="showSelectUrunGrupModalTs"
    (selectedUrunGrup)="selectUrunGrup($event)"></app-urun-grup-sec-modal>

  <app-cari-kayit-modal [show]="showYeniCariModalTs" (yeniCari)="yeniCariEkle($event)">
  </app-cari-kayit-modal>

  <app-teklif-fiyat-gecmisi-modal [source2]="teklifFiyatGecmisiTeklif" [show]="showTeklifFiyatGecmisiModalTs">
  </app-teklif-fiyat-gecmisi-modal>

  <!-- <app-cari-kayit-modal [show]="showYeniCariModalTs" (yeniCari)="yeniCariEkle($event)"> -->
  <div class="row" *ngIf="talep">
    <div class="col-12" *ngIf="id!=='0' && talep">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Talep Onay Hareketleri</h4>
        </div>
        <div class="card-body p-0">
          <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table card-table table-vcenter text-nowrap datatable">
                  <thead>
                    <tr>
                      <th>Durum</th>
                      <th>Onay Durumu</th>
                      <th>Kullanıcı</th>
                      <th>Tarih</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody *ngIf="talepHareketler">
                    <tr>
                      <td>Oluşturuldu</td>
                      <td>Onaylandı</td>
                      <td>{{talep.kullanici.adSoyad}}</td>
                      <td>{{talep.olusturmaTarihiText}}</td>
                    </tr>
                    <tr *ngFor="let k of talepHareketler">
                      <td>{{k.talepOnaySeviye?.kullaniciGrup?.isim}} onayında</td>
                      <td>{{k.isOnayText}}</td>
                      <td>{{k.kullanici?.adSoyad}}</td>
                      <td>{{k.olusturmaTarih | date: 'dd.MM.yyyy HH:mm:ss'}}</td>
                      <td class="text-right">
                        <div class="btn btn-sm btn-pill btn-success"
                          *ngIf="k.talepOnaySeviye.id===talep.talepOnaySeviyeId && k.talepOnaySeviye?.kullaniciGrupId===userGrupId && k.isOnay==null"
                          (click)="talepOnayla(k.talepOnaySeviye?.id,true)">Onayla
                        </div>
                        <div class="btn btn-sm btn-pill btn-danger ml-2"
                          *ngIf="k.talepOnaySeviye.id===talep.talepOnaySeviyeId && k.talepOnaySeviye?.kullaniciGrupId===userGrupId && k.isOnay==null"
                          (click)="talepOnayla(k.talepOnaySeviye.id,false)">Reddet
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title" [innerText]="id==='0'?'Yeni Talep':'Talep Düzenle :'"></h4>
          <div class="card-title">&nbsp;{{talep.talepNo}}</div>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="save()"
              *ngIf="userGrupId === 1 || (id === '0' || (talepHareketler && talepHareketler.length > 0 && talepHareketler[talepHareketler.length - 1].talepOnaySeviye.kullaniciGrupId === userGrupId && talepHareketler[talepHareketler.length - 1].isOnay == null))"
              [innerText]="id==='0'? 'Oluştur':'Değişiklikleri Kaydet'"></div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Şube</div>
                <app-loading-input *ngIf="!subeler"></app-loading-input>
                <select *ngIf="subeler" class="form-control" [(ngModel)]="talep.subeId"
                  [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let p of subeler" [ngValue]="p.id">{{p.isim}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Ürün Grubu</div>
                <input type="text" class="form-control clickable" placeholder="Ürün grubu adı" [readOnly]="true"
                  [value]="selectedUrunGrupText" (click)="showSelectUrunGrup()">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Talep Türü</div>
                <app-loading-input *ngIf="!talepTurler"></app-loading-input>
                <select *ngIf="talepTurler" class="form-control" [(ngModel)]="talep.talepTurId"
                  [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let p of talepTurler" [ngValue]="p.id">{{p.isim}}</option>
                </select>
              </div>

              <div class="mb-3"
                *ngIf="(talep.durum <= DURUM_TEKLIF_TOPLA || talep.durumText == '') && talep.talepTurId === 3">
                <!--burayı düzeltmek lazım-->
                <div class="card p-0">
                  <div class="card-header">
                    <h3 class="card-title">Cari: {{secilenCari?.firmaUnvani}}</h3>
                  </div>
                  <div class="card-body border-bottom py-3">
                    <div class="d-flex">
                      <div class="mr-auto text-muted">
                        Arama yap:
                        <div class="ml-2 d-inline-block">
                          <div class="input-icon mb-3">
                            <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="cariAraLoading">
                              <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                            </span>
                            <input name="cariAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                              [(ngModel)]="cariAraText" placeholder="Yazın ve Enter'a basın"
                              (keyup.enter)="cariAraInputChange()">
                          </div>
                        </div>
                      </div>
                      <div class="text-muted">
                        Gösterilen
                        <div class="mx-2 d-inline-block">
                          <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCountCari"
                            (change)="cariAraInputChange()">
                            <option *ngFor="let p of showSearchResultCountModelCari" [ngValue]="p">{{p}}</option>
                          </select>
                        </div>
                        sonuç sayısı
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive" *ngIf="searchResultsCari && searchResultsCari.results">
                    <table class="table card-table table-vcenter text-nowrap datatable">
                      <thead>
                        <tr>
                          <th class="w-1">Cari Kodu</th>
                          <th>Firma Unvanı</th>
                          <th>Şehir</th>
                          <th>Telefon</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let c of searchResultsCari.results;let i=index" class="">
                          <td><span class="text-muted">{{c.cariKodu}}</span></td>
                          <td>{{c.firmaUnvani}}</td>
                          <td>{{c.sehir?.aciklama}}</td>
                          <td>{{c.telefon}}</td>
                          <td class="text-right">
                            <div class="btn btn-sm btn-success" (click)="cariSec(c)">Seç</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="card-footer d-flex align-items-center" *ngIf="searchResultsCari">
                    <p class="m-0 text-muted"><span>{{searchResultsCari.rowCount}}
                        sonuçtan
                        {{searchResultsCari.firstRowOnPage}}</span>-<span>{{searchResultsCari.lastRowOnPage}}</span>
                      arası
                      sonuçlar
                    </p>
                    <ul class="pagination m-0 ml-auto">
                      <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageCari === 1}">
                        <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResultsCari()">
                          <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24"
                            viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                            stroke-linecap="round" stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z"></path>
                            <polyline points="15 6 9 12 15 18"></polyline>
                          </svg>
                          önceki
                        </div>
                      </li>
                      <li class="page-item"
                        [ngClass]="{'disabled':showSearchCurrentPageCari === searchResultsCari.pageCount}">
                        <div class="page-link" (click)="showNextPageSearchResultsCari()">
                          sonraki
                          <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24"
                            viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                            stroke-linecap="round" stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z"></path>
                            <polyline points="9 6 15 12 9 18"></polyline>
                          </svg>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Açıklama</label>
                <textarea class="form-control" name="example-textarea-input" rows="3" placeholder="Açıklama.."
                  [(ngModel)]="talep.aciklama"></textarea>
              </div>

              <div class="mb-3" *ngIf="talep.id">
                <div class="form-label">Talep Durumu</div>
                <span class="text-blue"><b>Durumu: </b> {{talep.durumText}}</span><br>
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <!-- <div class="mb-3">
                  <label class="form-label">Teslim Yeri</label>
                  <app-loading-input *ngIf="!teslimYerleri"></app-loading-input>
                  <select *ngIf="teslimYerleri" class="form-control" [(ngModel)]="talep.teslimYeriId"
                    [ngModelOptions]="{standalone: true}">
                    <option [value]="null" disabled selected>Seçiniz</option>
                    <option *ngFor="let p of teslimYerleri" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select>
                </div> -->

                <app-aciklama-gecmisi [source]="aciklamaGecmisi"></app-aciklama-gecmisi>

              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-lg-4">
              <div class="mb-3">
                <div class="form-label">Görsel</div>
                <div class="form-file">
                  <input id="fileSelect" type="file" class="form-file-input" accept="image/*"
                    (change)="onFileChanged($event)">
                  <label class="form-file-label" for="fileSelect">
                    <span class="form-file-text">Dosya Seç...</span>
                    <span class="form-file-button">Göz At</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-8">
              <div class="mb-3">
                <div class="row row-sm">
                  <div class="col-6 col-sm-3 attachment" *ngFor="let g of talep.talepGorseller;let index = i">
                    <div class="container">
                      <img [src]="g.getUri()" alt="" class="image" style="width:100%">
                      <div class="middle">
                        <div class="card-body">
                          <div class="d-flex align-items-center">
                            <div class="ml-auto">
                              <a class="text clickable" (click)="removeGorsel(index)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-md" width="24" height="24"
                                  viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                                  stroke-linecap="round" stroke-linejoin="round">
                                  <path stroke="none" d="M0 0h24v24H0z"></path>
                                  <line x1="18" y1="6" x2="6" y2="18"></line>
                                  <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                                Sil
                              </a>
                              <br>
                              <a class="ml-3 text clickable" (click)="downloadFile(g.dosya)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24"
                                  viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                                  stroke-linecap="round" stroke-linejoin="round">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                  <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                                  <polyline points="7 11 12 16 17 11"></polyline>
                                  <line x1="12" y1="4" x2="12" y2="16"></line>
                                </svg>
                                Görüntüle
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="container">
                      <img [src]="g.getUri()" alt="" class="image" style="width:100%">
                      <div class="middle">
                        <div class="text clickable" (click)="removeGorsel(index)">
                    <div class="text clickable" (click)="downloadFile(g.dosya)">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-md" width="24" height="24"
                        viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                        stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z"></path>
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </div>
                  </div>
                </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Sipariş Kalemleri</h3>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="kalemKaldir()"
              *ngIf="id !== '0' && (userGrupId === 5 || userGrupId === 6)">Kalemleri Kaydet
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table *ngIf="talep?.talepKalemler?.length>0" class="table card-table table-vcenter text-nowrap datatable">
            <thead>
              <tr>
                <th class="w-1">Stok Kodu</th>
                <th>Stok Adı</th>
                <th>Talep Edilen Miktar</th>
                <th>Ölçü Birimi</th>
                <th>Sarf Yeri</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let k of talep.talepKalemler;let i=index;" [id]="'cart'+i">
                <td><span class="text-muted">{{k.stokKodu}}</span></td>
                <td><input type="text" class="form-control" [(ngModel)]="k.stokAdi" [readOnly]="true"></td>
                <td><input type="number" class="form-control" [(ngModel)]="k.talepEdilen" [readOnly]="false" min="1">
                </td>
                <td>{{k.olcuBirimi}}</td>
                <td><select *ngIf="sarfYeriList" class="form-control" [(ngModel)]="k.sarfYeriId"
                    [ngModelOptions]="{standalone: true}">
                    <option [value]="null" disabled selected>Şeçiniz</option>
                    <option *ngFor="let p of sarfYeriList" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select>
                  <td [ngSwitch]="k.paraBirimiId">
                    {{k.sonAlisFiyati}}
                    <span *ngSwitchCase="1"> $</span> 
                    <span *ngSwitchCase="0"> ₺</span> 
                    <span *ngSwitchDefault></span> 
                    <span *ngIf="k.gecenSure>0"> ({{k.gecenSure}} ay önce)</span>
                  </td>
                <td class="text-right">
                  <div class="btn btn-sm btn-danger" (click)="removeFromRequestList(i)">Kaldır</div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center p-3" *ngIf="talep?.talepKalemler?.length===0">
            Kalem eklenmedi!
          </div>
        </div>
      </div>
    </div>
    <div class="col-12"
      *ngIf="id === '0' || (talepHareketler && talepHareketler.length > 0 && talepHareketler[talepHareketler.length - 1].talepOnaySeviye.kullaniciGrupId === userGrupId && talepHareketler[talepHareketler.length - 1].isOnay == null)">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Yeni Sipariş Kalemi</h3>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                  <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="kalemAraLoading">
                    <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                  </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                    [(ngModel)]="kalemAraText" placeholder="Yazın ve Enter'a basın"
                    (keyup.enter)="kalemAraInputChange()">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCount"
                  (change)="kalemAraInputChange()">
                  <option *ngFor="let p of showSearchResultCountModel" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <div class="table-responsive" *ngIf="searchResults && searchResults.results">
          <table class="table card-table table-vcenter text-nowrap datatable">
            <thead>
              <tr>
                <th class="w-1">Stok Kodu</th>
                <th>Stok Adı</th>
                <th>Asgari Stok Miktarı</th>
                <th>Stok Miktarı</th>
                <th>Talep Edilen Miktar</th>
                <th>Ölçü Birimi</th>
                <th>Sarf Yeri</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let k of searchResults.results;let i=index" [id]="'row'+i">
                <td><span class="text-muted">{{k.stokKodu}}</span></td>
                <td><input type="text" class="form-control" [(ngModel)]="k.stokAdi"
                    [readOnly]="k.stokKodu.search('HIZMET')"></td>
                <td>{{k.asgariStok}}</td>
                <td>{{k.mevcutStok}}</td>
                <td><input type="number" class="form-control" [(ngModel)]="k.talepEdilen" [readOnly]="false" min="1">
                </td>
                <td>{{k.olcuBirimi}}</td>
                <td>
                  <select *ngIf="sarfYeriList" class="form-control" [(ngModel)]="k.sarfYeriId"
                    [ngModelOptions]="{standalone: true}">
                    <option [value]="null" disabled selected>Şeçiniz</option>
                    <option *ngFor="let p of sarfYeriList" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select>
                </td>
                <td class="text-right">
                  <div class="btn btn-sm btn-success" (click)="addToRequestList(k,'row'+i)">Ekle</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer d-flex align-items-center" *ngIf="searchResults">
          <p class="m-0 text-muted"><span>{{searchResults.rowCount}}
              sonuçtan {{searchResults.firstRowOnPage}}</span>-<span>{{searchResults.lastRowOnPage}}</span> arası
            sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPage === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResults()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPage === searchResults.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResults()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="teklifIsteGosterGizle || tekliflerVisible">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Teklifler</h3>
        </div>
        <div class="card-body border-bottom py-3">
        </div>
        <div class="table-responsive" *ngIf="talep.teklifler">
          <table class="table card-table table-vcenter text-nowrap datatable">
            <thead>
              <tr>
                <th class="w-1">Cari Kodu</th>
                <th>Firma Unvanı</th>
                <th>Şehir</th>
                <th>Telefon</th>
                <th>E-Posta Gönder</th>
                <th>Durum</th>
                <th>Tarih</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of talep.teklifler">
                <td><a href="#/cari?id={{t.cari?.id}}" target="_blank">{{t.cari?.cariKodu}}</a></td>
                <td>{{t.cari?.firmaUnvani}}</td>
                <td>{{t.cari?.sehir?.aciklama}}</td>
                <td>{{t.cari?.telefon}}</td>
                <td>
                  <div [class]="t.mailGonder ? 'btn btn-sm btn-outline-success' : 'btn btn-sm btn-success'"
                    (click)="teklifMailGonder(t)">
                    {{t.mailGonder ? 'Tekrar Gönder' : 'E-Posta Gönder'}}
                  </div>
                  <!-- <span class="text-blue clickable"
                    (click)="teklifMailGonder(t)"></span> -->
                </td>
                <td>{{t.durumText}}</td>
                <td>{{t.mailTarihi | date: 'dd.MM.yyyy HH:mm:ss'}}</td>
                <td class="text-right">
                  <div *ngIf="t.durum===TEKLIF_DURUM_INITIAL" class="btn btn-sm btn-outline-primary mr-2"
                    (click)="teklifGir(t)">Teklif Gir
                  </div>
                  <div *ngIf="(userGrupId === 5 || userGrupId === 6) && (t.durum === TEKLIF_DURUM_CEVAPLANDI || t.durum === TEKLIF_DURUM_REVIZE_EDILDI)" class="btn btn-sm btn-primary mr-2"
                    (click)="incele(t,ACTION_TEKLIF_REVIZE)">Revize Et
                  </div>
                  <div class="btn btn-sm btn-primary mr-2" (click)="teklifDetay(t)">Detay</div>
                  <div *ngIf="t.isTeklifFiyatDegisti" class="btn btn-sm btn-warning"
                    (click)="showTeklifFiyatGecmisi(t.id)">Eski
                    Fiyatları Göster</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-12" *ngIf="teklifIsteGosterGizle && talep && (talep.durum === DURUM_TEKLIF_TOPLA || (talep.talepTurId === 1 && userGrupId === 5) 
                   || (talep.toplamTalepEdilenMiktar - talep.toplamSiparisEdilenMiktar > 0))">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Cari Ara</h3>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                  <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="cariAraLoading">
                    <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                  </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                    [(ngModel)]="cariAraText" placeholder="Yazın ve Enter'a basın" (keyup.enter)="cariAraInputChange()">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCountCari"
                  (change)="cariAraInputChange()">
                  <option *ngFor="let p of showSearchResultCountModelCari" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>

          <div class="mb-3" *ngIf="butonYeniCari">
            <button class="btn btn-sm btn-success" (click)="showCariKayitModal()">
              Yeni Cari Kayıt
            </button>
          </div>
        </div>
        <div class="table-responsive" *ngIf="searchResultsCari && searchResultsCari.results">
          <table class="table card-table table-vcenter text-nowrap datatable">
            <thead>
              <tr>
                <th class="w-1">Cari Kodu</th>
                <th>Firma Unvanı</th>
                <th>Şehir</th>
                <th>Telefon</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of searchResultsCari.results;let i=index" class="">
                <td><a href="#/cari?id={{c.id}}" target="_blank">{{c.cariKodu}}</a></td>
                <td>{{c.firmaUnvani}}</td>
                <td>{{c.sehir?.aciklama}}</td>
                <td>{{c.telefon}}</td>
                <td class="text-right">
                  <div class="btn btn-sm btn-success" (click)="addCari(c)">Ekle</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer d-flex align-items-center" *ngIf="searchResultsCari">
          <p class="m-0 text-muted"><span>{{searchResultsCari.rowCount}}
              sonuçtan {{searchResultsCari.firstRowOnPage}}</span>-<span>{{searchResultsCari.lastRowOnPage}}</span>
            arası
            sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageCari === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResultsCari()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageCari === searchResultsCari.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResultsCari()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-12" *ngIf="teklifIsteGosterGizle && talep && (talep.durum === DURUM_TEKLIF_TOPLA || (talep.talepTurId === 1 && userGrupId === 5) 
                   || (talep.toplamTalepEdilenMiktar - talep.toplamSiparisEdilenMiktar > 0))">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Teklif İstenecek Firmalar</h3>
        </div>
        <div class="card-body border-bottom py-3">
        </div>
        <div class="table-responsive" *ngIf="searchResultsCari && searchResultsCari.results">
          <table class="table card-table table-vcenter text-nowrap datatable">
            <thead>
              <tr>
                <th class="w-1">Cari Kodu</th>
                <th>Firma Unvanı</th>
                <th>Şehir</th>
                <th>Telefon</th>
                <th>E-Posta Gönder</th>
                <th>Görsel Göster/Gizle</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of teklifIsteFirmalar; let i = index">
                <td><a href="#/cari?id={{c.id}}" target="_blank">{{c.cariKodu}}</a></td>
                <td>{{c.firmaUnvani}}</td>
                <td>{{c.sehir?.aciklama}}</td>
                <td>{{c.telefon}}</td>
                <td><label class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="c.epostaGonder">
                    <span class="form-check-label">E-Posta Gönder</span>
                  </label></td>
                  <td><label class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="c.gorselGoster">
                      <span class="form-check-label">Görsel Göster/Gizle</span>
                    </label></td>
                <td class="text-right">
                  <div class="btn btn-sm btn-danger" (click)="removeCari(i)">İptal</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer d-flex align-items-center" *ngIf="teklifIsteFirmalar.length>0">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <div class="form-label">Teslim Yeri</div>
                <app-loading-input *ngIf="teslimYerleri==null"></app-loading-input>
                <select *ngIf="teslimYerleri" class="form-control" [(ngModel)]="selectedTeslimYeriId"
                  [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let p of teslimYerleri" [ngValue]="p.id">{{p.aciklama}}</option>
                </select>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <div class="form-label">Satın Alma Notu</div>
                <textarea class="form-control" name="example-textarea-input" rows="2" placeholder="Satın Alma Notu"
                  [(ngModel)]="satinAlmaNotu"></textarea>
              </div>
            </div>
            <ul class="m-0 text-right">
              <div class="btn btn-success" (click)="fiyatIste()">Fiyat İste</div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout>